var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { scrubber } from './scrubber';
import { attempt, parse, serialize } from './utils';
/**
 * Returns a "sanitized" URL that:
 * - Adds a base host if URL is relative
 * - Removes query strings & anchors
 */
export function getSanitizedURL(url) {
    var sanitized = new URL(url, window.location.origin);
    return sanitized.protocol + "//" + sanitized.host + sanitized.pathname;
}
export function getAllowListMatches(options, data) {
    var _a;
    var allowList = options.allowList;
    // even though LR types require method of type string,
    // method will return as undefined for certain fetch calls
    var _b = data.method, method = _b === void 0 ? 'GET' : _b, url = data.url;
    var sanitizedUrl = attempt(function () { return getSanitizedURL(url); });
    if (!sanitizedUrl)
        return [];
    // need to account for scenario where allowList has multiple items
    // with the same url and method, and find all matches
    var allowListMatches = (_a = allowList === null || allowList === void 0 ? void 0 : allowList.filter(function (item) {
        // compare url to item.url from allowList where item.url has wildcard
        var itemUrl = item.url
            .replace(/\./gi, '\\.')
            .replace(/\*/g, '[^\\/\\.]*');
        var regex = RegExp(itemUrl);
        return regex.test(sanitizedUrl) && item.method === method;
    })) !== null && _a !== void 0 ? _a : [];
    return allowListMatches;
}
export function sanitizeHeader(options) {
    var type = options.type, customMask = options.customMask, _a = options.globalAllowList, globalAllowList = _a === void 0 ? {} : _a;
    return function (data) {
        var _a, _b;
        var headers = data.headers;
        var allowListMatches = getAllowListMatches(options, data);
        var globalHeaderAllowList = (_b = (_a = globalAllowList[type]) === null || _a === void 0 ? void 0 : _a.headers) !== null && _b !== void 0 ? _b : [];
        // array containing all headers from allowList
        var headerAllowList = allowListMatches.reduce(function (acc, item) {
            var _a, _b;
            return __spread(acc, ((_b = (_a = item[type]) === null || _a === void 0 ? void 0 : _a.headers) !== null && _b !== void 0 ? _b : []));
        }, []);
        var combinedHeaderAllowList = headerAllowList.concat(globalHeaderAllowList);
        var scrubHeaders = scrubber({
            allowList: combinedHeaderAllowList,
            customMask: customMask,
        });
        var scrubbedHeaders = scrubHeaders(headers);
        return __assign(__assign({}, data), { headers: scrubbedHeaders });
    };
}
export function sanitizeBody(options) {
    var type = options.type, customMask = options.customMask, _a = options.globalAllowList, globalAllowList = _a === void 0 ? {} : _a;
    return function (data) {
        var _a, _b, _c;
        var body = data.body;
        if (!body)
            return data;
        if (typeof body !== 'object')
            return __assign(__assign({}, data), { body: (_a = options.customMask) !== null && _a !== void 0 ? _a : '*' });
        var allowListMatches = getAllowListMatches(options, data);
        var globalBodyAllowList = (_c = (_b = globalAllowList[type]) === null || _b === void 0 ? void 0 : _b.body) !== null && _c !== void 0 ? _c : [];
        // array containing all bodies from allowList
        var bodyAllowList = allowListMatches.reduce(function (acc, item) {
            var _a, _b;
            return __spread(acc, ((_b = (_a = item[type]) === null || _a === void 0 ? void 0 : _a.body) !== null && _b !== void 0 ? _b : []));
        }, []);
        var combinedBodyAllowList = bodyAllowList.concat(globalBodyAllowList);
        var scrubBody = scrubber({ allowList: combinedBodyAllowList, customMask: customMask });
        var scrubbedBody = scrubBody(body);
        return __assign(__assign({}, data), { body: scrubbedBody });
    };
}
// LogRocket will call one of the sanitizer functions and provide the data argument
export function sanitizer(options) {
    return function (data) {
        var parsedData = parse(data);
        var dataWithSanitizedHeader = sanitizeHeader(options)(parsedData);
        var dataWithSanitizedBody = sanitizeBody(options)(dataWithSanitizedHeader);
        var serializedData = serialize(dataWithSanitizedBody);
        return serializedData;
    };
}
//# sourceMappingURL=sanitizer.js.map